/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { StatusHistoryRecord } from './status-history-record';

export interface BottleGroupDto { 
    /**
     * Total number of bottles in group
     */
    bottlesNumber?: number;
    /**
     * The internal title
     */
    internalTitle?: string;
    /**
     * The expected price per bottle
     */
    expectedBottlePrice?: number;
    /**
     * The excepted price currency
     */
    expectedBottlePriceCurrency?: string;
    /**
     * Bottle group id
     */
    id?: number;
    /**
     * Parent batch id
     */
    parentBatchId?: number;
    /**
     * Parent batch title
     */
    parentBatchTitle?: string;
    /**
     * Bottle group status
     */
    bottleGroupStatus?: BottleGroupStatusEnum;
    /**
     * The whole status history for bottle group
     */
    statusHistoryRecords?: Array<StatusHistoryRecord>;
}















export enum BottleGroupStatusEnum {
    ReadyForTagging = 'ready_for_tagging',
    TaggingInProgress = 'tagging_in_progress',
    ReadyForMarket = 'ready_for_market'
}




